export default "__VITE_ASSET__BtBu1PAj__"